export const isEmail = (email) => (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email));

export const formatarTelefone = (telefone) => {
  var numero = telefone.replace(/\D/g, "");

  if (String(telefone).length < 16) {

    numero = numero.replace(/^(\d\d)(\d)/g, "($1) $2");
    numero = numero.replace(/(\d{5})(\d)/, "$1-$2");

    return numero;
  }
}

export const maskCEP = (value) => {
  return value.replace(/\D/g, "").replace(/^(\d{5})(\d{3})+?$/, "$1-$2");
};